package kpt.core.base.database.infra.dao

import androidx.room3.EntityDeleteOrUpdateAdapter
import androidx.room3.EntityInsertAdapter
import androidx.room3.EntityUpsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kpt.core.base.database.infra.entity.BookkeeperEntity

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "OPT_IN_USAGE_ERROR", "OPT_IN_USAGE", "MemberExtensionConflict", "CAN_BE_VAL"])
internal class BookkeeperDao_Impl(
  __db: RoomDatabase,
) : BookkeeperDao {
  private val __db: RoomDatabase

  private val __upsertAdapterOfBookkeeperEntity: EntityUpsertAdapter<BookkeeperEntity>
  init {
    this.__db = __db
    this.__upsertAdapterOfBookkeeperEntity = EntityUpsertAdapter<BookkeeperEntity>(object : EntityInsertAdapter<BookkeeperEntity>() {
      protected override fun createQuery(): String = "INSERT INTO `store_bookkeeper` (`key`,`lastFailedSync`) VALUES (?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: BookkeeperEntity) {
        statement.bindText(1, entity.key)
        statement.bindLong(2, entity.lastFailedSync)
      }
    }, object : EntityDeleteOrUpdateAdapter<BookkeeperEntity>() {
      protected override fun createQuery(): String = "UPDATE `store_bookkeeper` SET `key` = ?,`lastFailedSync` = ? WHERE `key` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: BookkeeperEntity) {
        statement.bindText(1, entity.key)
        statement.bindLong(2, entity.lastFailedSync)
        statement.bindText(3, entity.key)
      }
    })
  }

  public override suspend fun upsert(entity: BookkeeperEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __upsertAdapterOfBookkeeperEntity.upsert(_connection, entity)
  }

  public override suspend fun getLastFailedSync(key: String): Long? {
    val _sql: String = "SELECT lastFailedSync FROM store_bookkeeper WHERE `key` = ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, key)
        val _result: Long?
        if (_stmt.step()) {
          if (_stmt.isNull(0)) {
            _result = null
          } else {
            _result = _stmt.getLong(0)
          }
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun pendingKeys(): List<String> {
    val _sql: String = "SELECT `key` FROM store_bookkeeper ORDER BY lastFailedSync ASC"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: MutableList<String> = mutableListOf()
        while (_stmt.step()) {
          val _item: String
          _item = _stmt.getText(0)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun delete(key: String) {
    val _sql: String = "DELETE FROM store_bookkeeper WHERE `key` = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, key)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteAll() {
    val _sql: String = "DELETE FROM store_bookkeeper"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
